import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';

@Injectable({
    providedIn: 'root'
})
export class HeadCounsellorService extends BaseService {
    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService) {
        super(http, alertService, globalService);
    }

    get(data): Observable<any> {
        return this.getRequest(AppUrl.HEAD_COUNSELLORS(), data);
    }

    count(): Observable<any> {
        return this.getRequest(AppUrl.HEAD_COUNSELLORS_COUNT());
    }

    detail(id): Observable<any> {
        return this.getRequest(AppUrl.HEAD_COUNSELLORS(id));
    }

    create(data): Observable<any> {
        return this.postRequest(AppUrl.HEAD_COUNSELLORS(), data);
    }

    update(id, data): Observable<any> {
        return this.putRequest(AppUrl.HEAD_COUNSELLORS(id), data);
    }

    updatePassword(id, data): Observable<any> {
        return this.putRequest(AppUrl.HEAD_COUNSELLOR_PASSWORD(id), data);
    }

    updateStatus(id, data): Observable<any> {
        return this.putRequest(AppUrl.HEAD_COUNSELLOR_STATUS(id), data);
    }

    updateUniqueLinkStatus(id, data): Observable<any> {
        return this.putRequest(AppUrl.HEAD_COUNSELLOR_UNIQUE_LINK_STATUS(id), data);
    }

    headCounsellorUniversity(id, data): Observable<any> {
        return this.putRequest(AppUrl.HEAD_COUNSELLOR_UNIVERSITY(id), data);
    }

    getCounsellorUniversities(id, data): Observable<any> {
        return this.getRequest(AppUrl.HEAD_COUNSELLOR_UNIVERSITY(id), data);
    }

    updateProfile(id, data): Observable<any> {
        return this.putRequest(AppUrl.HEAD_COUNSELLORS_PROFILE_IMAGE(id), data);
    }

    getHeadCounsellorReportCount(id): Observable<any> {
        return this.getRequest(AppUrl.HEAD_COUNSELLORS_PROGRESS_REPORT_COUNT(id));
    }

    getHeadCounsellorsCounsellors(id, data): Observable<any> {
        return this.getRequest(AppUrl.HEAD_COUNSELLORS_COUNSELLORS(id), data);
    }
}
